<template>
  <div :class="[getWidth, ifImage]" class="farming-content">
    <TextProse>
      <p>Morrisons is committed to British produce. It’s at the heart of our unique Market Street, with a butcher’s counter, green grocer, baker and fishmonger in almost every Morrisons supermarket.</p>
      <p>But we are far more than just a retailer, we are also one of Britain's biggest food manufacturers, with over 20 food production and distribution sites around the UK. We call this Vertical Integration, because we have closer, more direct links with our farmers, enabling us to deliver the freshest food and the best value to our customers.</p>
      <p>To learn more about how we operate in the different sectors of UK agriculture by clicking on the links below.</p>
    </TextProse>
    <figure v-if="image">
      <img :src="getImage" alt="Alt description for the image">
    </figure>
  </div>
</template>

<script>
import TextProse from '../elements/TextProse.vue'
export default {
  name: 'PageFarmingContent',
  components: { TextProse },
  props: {
    image: {
      type: String,
      default: ''
    },
    narrow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getImage() {
      return require('@/assets/images/' + this.image)
    },
    getWidth() {
      return `${(this.narrow && 'farming-content--narrow') || ''}`
    },
    ifImage() {
      return `${(this.image && 'farming-content--image') || ''}`
    }
  }
}
</script>

<style lang="postcss">
.farming-content {
  @apply flex flex-wrap;
}
.farming-content .prose {
  @apply w-full mb-0;
}
.farming-content--image .prose {
  @apply mb-8;
}
.farming-content figure {
  @apply relative overflow-hidden w-full;
}
.farming-content figure > img {
  @apply block relative inset-y-0 inset-x-0 w-full max-w-xs mx-auto;
  object-fit: contain;
}
.farming-content--narrow {
  @apply w-full mx-auto;
}
@screen sm {
  .farming-content figure > img {
    @apply w-1/2 max-w-full;
  }
}
@screen md {
  .farming-content {
    @apply flex-no-wrap;
  }
  .farming-content--image .prose {
    @apply mb-0 pr-6 w-8/12;
  }
  .farming-content figure {
    @apply ml-6 flex-1;
  }
  .farming-content figure > img {
    @apply w-full;
  }
  .farming-content--narrow {
    @apply w-8/12;
  }
}

@screen lg {
  .farming-content figure > img {
    @apply max-w-2/3;
  }
}
</style>